<div class="batch-warnings-component">
  <header class="batch-warnings__header">
    <div class="header-icons">
      <h2>{{ "taxReturns.batch-warnings-flags-comments" | transloco }}</h2>
      <div id="icons">
        <div
          (click)="selectTab(1)"
          class="notification-icon warnings-highlighted"
          [ngClass]="{ active: tab == 1 }"
        ></div>

        <div
          (click)="selectTab(2)"
          class="notification-icon flags-highlighted"
          [ngClass]="{ active: tab == 2 }"
        ></div>

        <div
          (click)="selectTab(3)"
          class="notification-icon comments-highlighted"
          [ngClass]="{ active: tab == 3 }"
        ></div>
      </div>
    </div>

    <div class="header-flex">
      @if (tab === 1) {
      <div class="empty-questions-toggle">
        <div class="ui slider checkbox">
          <input
            type="checkbox"
            name="toggle"
            (click)="updateFlag($event.target.checked)"
            checked
          />
          @if (showActiveAnswerWarnings) {
          <label>{{ "taxReturns.showing-active-warnings" | transloco }}</label>
          } @if (!showActiveAnswerWarnings) {
          <label>{{ "taxReturns.showing-closed-warnings" | transloco }}</label>
          }
        </div>
      </div>
      } @if (tab === 2) {
      <div class="empty-questions-toggle">
        <div class="ui slider checkbox">
          <input
            type="checkbox"
            name="toggle"
            (click)="updateFlag($event.target.checked)"
            checked
          />
          @if (showActiveAnswerWarnings) {
          <label>{{ "taxReturns.showing-active-flags" | transloco }}</label>
          } @if (!showActiveAnswerWarnings) {
          <label>{{ "taxReturns.showing-closed-flags" | transloco }}</label>
          }
        </div>
      </div>
      } @if (showInfo) {
      <div>
        {{
          "taxReturns.if-the-page-stops-responding-please-click-wait-while-the-tables-finishs-loading"
            | transloco
        }}
      </div>
      }
    </div>
  </header>

  @if ( tab === 1 && taxReturnStructure && taxReturnStructure.length &&
  !loadingWarning ) {
  <div class="batch-warnings__body">
    <div class="no-warnings-info">
      @if (( showActiveAnswerWarnings && !batchHasActiveWarnings )) {
      <div>{{ "taxReturns.no-active-warnings" | transloco }}</div>
      } @if (( !showActiveAnswerWarnings && !batchHasClosedWarnings )) {
      <div>{{ "taxReturns.no-closed-warnings" | transloco }}</div>
      }
    </div>
    <div class="left-bar hidden-scrollbar">
      @for (category of taxReturnStructure; track category) {
      <div class="category">
        @if (isItHasWarnings(category, tab)) {
        <div class="count">
          <div
            class="title"
            (click)="category['isCollapsed'] = !category.isCollapsed"
          >
            <i
              class="chevron icon"
              [ngClass]="{
                down: category.isCollapsed,
                up: !category.isCollapsed
              }"
            ></i>
            {{ category.name }}
          </div>
          @for (subCategory of category.subcategories; track subCategory) {
          <div [hidden]="category.isCollapsed" class="subcategory">
            @if (isItHasWarnings(subCategory, tab)) {
            <div>
              <div
                class="title"
                (click)="subCategory['isCollapsed'] = !subCategory.isCollapsed"
              >
                <i
                  class="chevron icon"
                  [ngClass]="{
                    down: subCategory.isCollapsed,
                    up: !subCategory.isCollapsed
                  }"
                ></i>
                {{ subCategory.name }}
              </div>
              @for (_question of subCategory['questions']; track _question) {
              <div class="question-group" [hidden]="subCategory.isCollapsed">
                @if (isItHasWarnings(_question, tab)) {
                <div>
                  <div
                    class="question"
                    (click)="selectQuestion(_question)"
                    [ngClass]="{
                      active: question?.id === _question.id,
                      not_selected: question?.id !== _question.id
                    }"
                  >
                    {{ _question?.id }}.{{ _question.question }}
                  </div>
                  <div class="question-warnings">
                    <!--  Validation warnings  -->
                    @if (showActiveAnswerWarnings) {
                    <div>
                      @for (warning of _question['sortedWarnings']; track
                      warning) {
                      <div class="d-flex question-group-validation-warnings">
                        @if (isItHasWarnings(warning, tab)) {
                        <div class="warning-container">
                          <div
                            class="warning-name"
                            (click)="selectWarning(warning, _question)"
                            [ngClass]="{
                              selectedWarning:
                                warning.name === selectedWarning?.name &&
                                _question.id === question?.id,
                              warning: warning.name !== selectedWarning?.name
                            }"
                          >
                            {{ warning.name }}
                          </div>
                          @for (w of warning.warnings; track w) {
                          <div class="validation-warning-taxReturn">
                            {{ w.atlasId }}. {{ w.firstName }}
                            {{ w.lastName }} &#8618;
                            <span
                              class="link"
                              (click)="goToSection(w, _question)"
                              >{{
                                "taxReturns.go-to-section" | transloco
                              }}</span
                            >
                          </div>
                          }
                        </div>
                        }
                      </div>
                      }
                    </div>
                    }
                    <!--  answerWarnings  -->
                    @if (warningsByQuestionId[_question?.id]) {
                    <div class="d-flex question-group-answer-warnings">
                      @for (answerWarning of
                      warningsByQuestionId[_question?.id]['sortedWarnings'];
                      track answerWarning) {
                      <div class="d-flex">
                        @if (isItHasWarnings(answerWarning, tab)) {
                        <div class="warning-container">
                          <div
                            class="warning-name"
                            (click)="selectWarning(answerWarning, _question)"
                            [ngClass]="{
                              selectedWarning:
                                answerWarning.name === selectedWarning?.name &&
                                _question.id === question?.id,
                              warning:
                                answerWarning.name !== selectedWarning?.name
                            }"
                          >
                            {{ answerWarning["name"] }}
                          </div>
                          @for (wa of answerWarning.warnings; track wa) {
                          <div>
                            @if (isItHasWarnings(wa, tab)) {
                            <div class="warning-taxReturn">
                              <span
                                [ngClass]="{
                                  selectedTaxReturnWarning:
                                    selectedTaxReturnWarning?.id === wa.id
                                }"
                                (click)="
                                  selectTaxReturnWarning(
                                    wa,
                                    answerWarning,
                                    _question
                                  )
                                "
                              >
                                {{ wa.atlasId }}. {{ wa.firstName }}
                                {{ wa.lastName }}
                              </span>
                              &#8618;
                              <span
                                class="link"
                                (click)="
                                  goToWarning(
                                    wa['taxReturnId'],
                                    subCategory.id,
                                    _question?.id
                                  )
                                "
                                >{{
                                  "taxReturns.go-to-section" | transloco
                                }}</span
                              >
                            </div>
                            }
                          </div>
                          }
                        </div>
                        }
                      </div>
                      }
                    </div>
                    }
                  </div>
                </div>
                }
              </div>
              }
            </div>
            }
          </div>
          }
        </div>
        }
      </div>
      }
    </div>
    @if (question) {
    <div class="table-group right-bar">
      <header class="question-warnings-header">
        <h3>{{ question.question }}</h3>
        @if (canRespondAndClose && selectedTaxReturnWarning) {
        <div class="header-action-area">
          <button
            class="ui primary button"
            (click)="openRespondAndCloseAllModal()"
          >
            {{ "taxReturns.respond-and-close" | transloco }}
          </button>
        </div>
        } @if (canRespondAndClose && !selectedTaxReturnWarning) {
        <div class="header-action-area">
          <button
            class="ui primary button"
            (click)="openRespondAndCloseAllModal()"
          >
            {{ "taxReturns.respond-and-close-all" | transloco }}
          </button>
          <small>{{
            "taxReturns.for-this-selected-warning" | transloco
          }}</small>
        </div>
        } @if (selectedWarning && isValidationWarning(selectedWarning)) {
        <div class="header-action-area">
          <small>
            {{ 'taxReturns.visit-the-tax-return-alias-section-from-the-left-menu' | transloco: {taxReturnAlias}
            }}<br />
            {{ "taxReturns.to-clear-this-warning" | transloco }}
          </small>
        </div>
        }
      </header>
      <div class="list-container">
        <div class="list-inner-cont">
          <div class="question-warnings">
            <!--  Validation warnings  -->
            @if (showActiveAnswerWarnings) {
            <div class="validation-warnings">
              @for (warning of question['sortedWarnings']; track warning) {
              <div class="d-flex sorted-warning-item">
                @if (isItHasWarnings(warning, tab) && ( (selectedWarning &&
                selectedWarning.name === warning.name) || !selectedWarning)) {
                <div class="warning-item">
                  <div class="warning-label">
                    <div class="ui red label">
                      {{ "taxReturns.critical" | transloco }}
                    </div>
                    <span class="validation-warning-label">{{
                      warning.name
                    }}</span>
                  </div>
                  <div class="labels">
                    <div class="ui label">
                      {{ question?.id }}.&nbsp;{{ question?.question }}
                    </div>
                  </div>
                </div>
                }
                <!--    On question selection -->
                @if (question && !selectedWarning && warning['subGroup']) {
                <div class="table-outer-container">
                  <div class="table-container">
                    <div class="table-card">
                      <div class="table-header-title">
                        <div class="title">
                          {{ taxpayerAlias }}
                        </div>
                        <div
                          class="icon"
                          (click)="
                            warning['subGroup']['isCollapsed'] = !warning[
                              'subGroup'
                            ].isCollapsed
                          "
                        >
                          <i
                            class="chevron icon"
                            [ngClass]="{
                              down: warning['subGroup']['isCollapsed'],
                              up: !warning['subGroup']['isCollapsed']
                            }"
                          ></i>
                        </div>
                      </div>
                      @if (!warning.subGroup.isCollapsed) {
                      <div class="table-body">
                        <table
                          cellpadding="0"
                          cellspacing="0"
                          class="sticky-header"
                        >
                          <thead>
                            <tr>
                              <th class="row-num"></th>
                              @for (question of warning.subGroup.questions;
                              track question) { @if (!question.hidden &&
                              !question.toggleOff) {
                              <th
                                title="{{ question?.question }}"
                                [ngClass]="{
                                  'checkbox-column': isBooleanCheckboxColumn(
                                    question
                                  )
                                }"
                              >
                                @if (question?.mandatory) {
                                <span
                                  class="column-mandatory"
                                  title="This column is mandatory"
                                  >*</span
                                >
                                }
                                <div class="text-ellipsis">
                                  {{ question?.question }}
                                </div>
                              </th>
                              } }
                            </tr>
                          </thead>
                          <tbody class="">
                            @for (rowAnswer of warning.subGroup.rows; track
                            trackByRow(index, rowAnswer); let index = $index) {
                            <app-question-table-row
                              [rowAnswer]="rowAnswer"
                              [deleted]="false"
                              [subGroup]="warning.subGroup"
                              [formGroup]="warning.subGroup.formGroup"
                              [groupId]="warning.subGroup.id"
                              [rowIndex]="index"
                              [readonly]="true"
                              [readonlyGlobal]="true"
                              [isSelected]="
                                warning.subGroup.activeRow === index
                              "
                              [hideClearOverRideQuestionIcon]="true"
                            ></app-question-table-row>
                            }
                          </tbody>
                        </table>
                        @if (warning && warning.showedUpto && (
                        warning.totalLength > warning.showedUpto ) && !showInfo)
                        {
                        <button
                          class="ui primary background button approve top-padded"
                          (click)="loadTaxpayersTableMoreData(warning)"
                        >
                          {{ "taxReturns.load-more" | transloco }}
                        </button>
                        }
                      </div>
                      }
                    </div>
                  </div>
                </div>
                }
              </div>
              }
            </div>
            }
            <!--  answerWarnings  -->
            @if (warningsByQuestionId[question?.id]) {
            <div class="d-flex question-group-answer-warnings-table">
              @for (answerWarning of
              warningsByQuestionId[question?.id]['sortedWarnings']; track
              answerWarning) {
              <div class="d-flex sorted-warning-item">
                @if (isItHasWarnings(answerWarning, tab) && ( (selectedWarning
                && selectedWarning.name === answerWarning.name) ||
                !selectedWarning)) {
                <div class="warning-item">
                  <div class="warning-label">
                    <div class="ui label">
                      {{ "taxReturns.review" | transloco }}
                    </div>
                  </div>
                  <div class="labels">
                    <div class="ui label">
                      {{ question?.id }}.&nbsp;{{ question?.question }}
                    </div>
                  </div>
                  <span> {{ answerWarning["name"] }} </span>
                </div>
                } @if (question && !selectedWarning && answerWarning.subGroup) {
                <div class="table-outer-container">
                  <div class="table-container">
                    <div class="table-card">
                      <div class="table-header-title">
                        <div class="title">
                          {{ taxpayerAlias }}
                        </div>
                        <div
                          class="icon"
                          (click)="
                            answerWarning.subGroup[
                              'isCollapsed'
                            ] = !answerWarning.subGroup.isCollapsed
                          "
                        >
                          <i
                            class="chevron icon"
                            [ngClass]="{
                              down: answerWarning.subGroup.isCollapsed,
                              up: !answerWarning.subGroup.isCollapsed
                            }"
                          ></i>
                        </div>
                      </div>
                      @if (!answerWarning.subGroup.isCollapsed) {
                      <div class="table-body">
                        <table
                          cellpadding="0"
                          cellspacing="0"
                          class="sticky-header"
                        >
                          <thead>
                            <tr>
                              <th class="row-num"></th>
                              @for (question of
                              answerWarning.subGroup.questions; track question)
                              { @if (!question.hidden && !question.toggleOff) {
                              <th
                                title="{{ question?.question }}"
                                [ngClass]="{
                                  'checkbox-column': isBooleanCheckboxColumn(
                                    question
                                  )
                                }"
                              >
                                @if (question?.mandatory) {
                                <span
                                  class="column-mandatory"
                                  title="This column is mandatory"
                                  >*</span
                                >
                                }
                                <div class="text-ellipsis">
                                  {{ question?.question }}
                                </div>
                              </th>
                              } }
                            </tr>
                          </thead>
                          <tbody class="">
                            @for (rowAnswer of answerWarning.subGroup.rows;
                            track trackByRow(index, rowAnswer); let index =
                            $index) {
                            <app-question-table-row
                              [rowAnswer]="rowAnswer"
                              [deleted]="false"
                              [subGroup]="answerWarning.subGroup"
                              [formGroup]="answerWarning.subGroup.formGroup"
                              [groupId]="answerWarning.subGroup.id"
                              [rowIndex]="index"
                              [readonly]="true"
                              [readonlyGlobal]="true"
                              [isSelected]="
                                answerWarning.subGroup.activeRow === index
                              "
                              [hideClearOverRideQuestionIcon]="true"
                            ></app-question-table-row>
                            }
                          </tbody>
                        </table>
                        @if (answerWarning && (answerWarning.totalLength &&
                        answerWarning.totalLength > answerWarning.showedUpto )
                        && !showInfo) {
                        <button
                          class="ui primary background button approve top-padded"
                          (click)="loadTaxpayersTableMoreData(answerWarning)"
                        >
                          {{ "taxReturns.load-more" | transloco }}
                        </button>
                        }
                      </div>
                      }
                    </div>
                  </div>
                </div>
                }
              </div>
              }
            </div>
            }
          </div>
        </div>
      </div>
      <!--    For each tax return display a table-->
      @if (question && question.taxReturns && !selectedTaxReturnWarning) {
      <div class="table-outer-container">
        @for (tr of question.taxReturns; track trackByTaxReturn(i, tr); let i =
        $index) {
        <div class="table-container">
          @if (numberOfTablesShowed >= (i+1 )) {
          <div class="table-wrapper">
            <span class="table-header-name"
              >{{ tr.atlasId }} {{ tr.firstName }} {{ tr.lastName }}
            </span>
            <div class="table-card">
              <div class="table-header-title">
                <div class="title">
                  {{ question?.parentQuestion?.question }}
                </div>
                <div class="icon" (click)="tr['isCollapsed'] = !tr.isCollapsed">
                  <i
                    class="chevron icon"
                    [ngClass]="{ down: tr.isCollapsed, up: !tr.isCollapsed }"
                  ></i>
                </div>
              </div>
              <div class="table-body">
                @if (!tr.isCollapsed) {
                <table cellpadding="0" cellspacing="0" class="sticky-header">
                  <thead>
                    <tr>
                      <th class="row-num"></th>
                      @for (question of tr.subGroup.questions; track question) {
                      @if (!question.hidden && !question.toggleOff) {
                      <th
                        title="{{ question?.question }}"
                        [ngClass]="{
                          'checkbox-column': isBooleanCheckboxColumn(question)
                        }"
                      >
                        @if (question?.mandatory) {
                        <span
                          class="column-mandatory"
                          title="This column is mandatory"
                          >*</span
                        >
                        }
                        <div class="text-ellipsis">
                          {{ question?.question }}
                        </div>
                      </th>
                      } }
                    </tr>
                  </thead>
                  <tbody class="">
                    @for (rowAnswer of tr.subGroup.rows; track trackByRow(index,
                    rowAnswer); let index = $index) {
                    <app-question-table-row
                      [rowAnswer]="rowAnswer"
                      [deleted]="false"
                      [subGroup]="tr.subGroup"
                      [formGroup]="tr.subGroup.formGroup"
                      [groupId]="tr.subGroup.id"
                      [rowIndex]="index"
                      [readonly]="true"
                      [readonlyGlobal]="true"
                      [isSelected]="tr.subGroup.activeRow === index"
                      [hideClearOverRideQuestionIcon]="true"
                    ></app-question-table-row>
                    }
                  </tbody>
                </table>
                } @if ((tr.showedUpto && tr.totalLength) && (tr.totalLength >
                tr.showedUpto) && !showInfo) {
                <button
                  class="ui primary background button approve top-padded"
                  (click)="loadTaxpayersTableFromTaxReturnMoreData(tr)"
                >
                  {{ "taxReturns.load-more" | transloco }}
                </button>
                }
              </div>
            </div>
          </div>
          } @if (i === numberOfTablesShowed) {
          <div>
            @if (!showInfo) {
            <button
              class="ui primary background button approve top-padded"
              (click)="loadMoreTables()"
            >
              {{ "taxReturns.load-more" | transloco }}
            </button>
            }
          </div>
          }
        </div>
        }
      </div>
      }
      <!--    On warning selection -->
      @if (question && selectedWarning && selectedWarning.subGroup) {
      <div class="table-outer-container">
        <div class="table-container">
          <div class="table-card">
            <div class="table-header-title">
              <div class="title">
                {{ taxpayerAlias }}
              </div>
              <div
                class="icon"
                (click)="
                  selectedWarning.subGroup['isCollapsed'] = !selectedWarning
                    .subGroup.isCollapsed
                "
              >
                <i
                  class="chevron icon"
                  [ngClass]="{
                    down: selectedWarning.subGroup.isCollapsed,
                    up: !selectedWarning.subGroup.isCollapsed
                  }"
                ></i>
              </div>
            </div>
            @if (!selectedWarning.subGroup.isCollapsed) {
            <div class="table-body">
              <table cellpadding="0" cellspacing="0" class="sticky-header">
                <thead>
                  <tr>
                    <th class="row-num"></th>
                    @for (question of selectedWarning.subGroup.questions; track
                    question) { @if (!question.hidden && !question.toggleOff) {
                    <th
                      title="{{ question?.question }}"
                      [ngClass]="{
                        'checkbox-column': isBooleanCheckboxColumn(question)
                      }"
                    >
                      @if (question?.mandatory) {
                      <span
                        class="column-mandatory"
                        title="This column is mandatory"
                        >*</span
                      >
                      }
                      <div class="text-ellipsis">{{ question?.question }}</div>
                    </th>
                    } }
                  </tr>
                </thead>
                <tbody class="">
                  @for (rowAnswer of selectedWarning.subGroup.rows; track
                  trackByRow(index, rowAnswer); let index = $index) {
                  <app-question-table-row
                    [rowAnswer]="rowAnswer"
                    [deleted]="false"
                    [subGroup]="selectedWarning.subGroup"
                    [formGroup]="selectedWarning.subGroup.formGroup"
                    [groupId]="selectedWarning.subGroup.id"
                    [rowIndex]="index"
                    [readonly]="true"
                    [readonlyGlobal]="true"
                    [isSelected]="selectedWarning.subGroup.activeRow === index"
                    [hideClearOverRideQuestionIcon]="true"
                  >
                  </app-question-table-row>
                  }
                </tbody>
              </table>
              @if (selectedWarning && selectedWarning.showedUpto && (
              selectedWarning.totalLength > selectedWarning.showedUpto ) &&
              !showInfo) {
              <button
                class="ui primary background button approve top-padded"
                (click)="loadTaxpayersTableMoreData(selectedWarning)"
              >
                {{ "taxReturns.load-more" | transloco }}
              </button>
              }
            </div>
            }
          </div>
        </div>
      </div>
      }
    </div>
    }
  </div>
  } @if ( tab === 2 && taxReturnStructure && taxReturnStructure.length &&
  !loadingWarning ) {
  <div class="batch-warnings__body">
    <div class="no-warnings-info">
      @if (( showActiveAnswerWarnings && !batchHasActiveFlags )) {
      <div>{{ "taxReturns.no-active-flags" | transloco }}</div>
      } @if (( !showActiveAnswerWarnings && !batchHasClosedFlags )) {
      <div>{{ "taxReturns.no-closed-flags" | transloco }}</div>
      }
    </div>
    <div class="left-bar hidden-scrollbar">
      @for (category of taxReturnStructure; track category) {
      <div class="category">
        @if (isItHasWarnings(category, tab)) {
        <div class="count">
          <div
            class="title"
            (click)="category['isCollapsed'] = !category.isCollapsed"
          >
            <i
              class="chevron icon"
              [ngClass]="{
                down: category.isCollapsed,
                up: !category.isCollapsed
              }"
            ></i>
            {{ category.name }}
          </div>
          @for (subCategory of category.subcategories; track subCategory) {
          <div [hidden]="category.isCollapsed" class="subcategory">
            @if (isItHasWarnings(subCategory, tab)) {
            <div>
              <div
                class="title"
                (click)="subCategory['isCollapsed'] = !subCategory.isCollapsed"
              >
                <i
                  class="chevron icon"
                  [ngClass]="{
                    down: subCategory.isCollapsed,
                    up: !subCategory.isCollapsed
                  }"
                ></i>
                {{ subCategory.name }}
              </div>
              @for (_question of subCategory['questions']; track _question) {
              <div class="question-group" [hidden]="subCategory.isCollapsed">
                @if (isItHasWarnings(_question, tab)) {
                <div>
                  <div
                    class="question"
                    (click)="selectQuestionFlag(_question)"
                    [ngClass]="{
                      active: question?.id === _question.id,
                      not_selected: question?.id !== _question.id
                    }"
                  >
                    {{ _question?.id }}.{{ _question.question }}
                  </div>
                  <div class="question-warnings">
                    <!--  answerFlags  -->
                    @if (flagsByQuestionId[_question?.id]) {
                    <div class="d-flex question-group-answer-warnings">
                      @for (answerFlag of
                      flagsByQuestionId[_question?.id]['sortedFlags']; track
                      answerFlag) {
                      <div class="d-flex">
                        @if (isItHasWarnings(answerFlag, tab)) {
                        <div class="warning-container">
                          <div
                            class="warning-name"
                            (click)="selectFlag(answerFlag, _question)"
                            [ngClass]="{
                              selectedWarning:
                                answerFlag.name === selectedFlag?.name &&
                                _question.id === question?.id,
                              warning: answerFlag.name !== selectedFlag?.name
                            }"
                          >
                            {{ answerFlag["name"] }}
                          </div>
                          @for (wa of answerFlag.flags; track wa) {
                          <div>
                            @if (isItHasWarnings(wa, tab)) {
                            <div class="warning-taxReturn">
                              <span
                                [ngClass]="{
                                  selectedTaxReturnWarning:
                                    selectedTaxReturnWarning?.id === wa.id
                                }"
                                (click)="
                                  selectTaxReturnFlag(wa, answerFlag, _question)
                                "
                              >
                                {{ wa.atlasId }}. {{ wa.firstName }}
                                {{ wa.lastName }}
                              </span>
                              &#8618;
                              <span
                                class="link"
                                (click)="
                                  goToWarning(
                                    wa['taxReturnId'],
                                    subCategory.id,
                                    _question?.id
                                  )
                                "
                                >{{
                                  "taxReturns.go-to-section" | transloco
                                }}</span
                              >
                            </div>
                            }
                          </div>
                          }
                        </div>
                        }
                      </div>
                      }
                    </div>
                    }
                  </div>
                </div>
                }
              </div>
              }
            </div>
            }
          </div>
          }
        </div>
        }
      </div>
      }
    </div>
    @if (question) {
    <div class="table-group right-bar">
      <header class="question-warnings-header">
        <h3>{{ question.question }}</h3>
        @if (canRespondAndClose && selectedTaxReturnWarning) {
        <div class="header-action-area">
          <button
            class="ui primary button"
            (click)="openRespondAndCloseAllModal()"
          >
            {{ "taxReturns.respond-and-close" | transloco }}
          </button>
        </div>
        } @if (canRespondAndClose && !selectedTaxReturnWarning) {
        <div class="header-action-area">
          <button
            class="ui primary button"
            (click)="openRespondAndCloseAllModal()"
          >
            {{ "taxReturns.respond-and-close-all" | transloco }}
          </button>
          <small>{{ "taxReturns.for-this-selected-flag" | transloco }}</small>
        </div>
        } @if (selectedFlag) {
        <div class="header-action-area">
          <small>
            {{ 'taxReturns.visit-the-tax-return-alias-section-from-the-left-menu' | transloco: {taxReturnAlias}
            }}<br />
            {{ "taxReturns.to-clear-this-flag" | transloco }}
          </small>
        </div>
        }
      </header>
      <div class="list-container">
        <div class="list-inner-cont">
          <div class="question-warnings">
            <!--  answerFlags  -->
            @if (flagsByQuestionId[question?.id]) {
            <div class="d-flex question-group-answer-warnings-table">
              @for (answerFlag of
              flagsByQuestionId[question?.id]['sortedFlags']; track answerFlag)
              {
              <div class="d-flex sorted-warning-item">
                @if (isItHasWarnings(answerFlag, tab) && ( (selectedFlag &&
                selectedFlag.name === answerFlag.name) || !selectedFlag)) {
                <div class="warning-item">
                  <div class="flag-label">
                    <div class="ui label">{{ answerFlag["name"] }}</div>
                  </div>
                  <div class="labels">
                    <div class="ui label">
                      {{ question?.id }}.&nbsp;{{ question?.question }}
                    </div>
                  </div>
                </div>
                } @if (question && !selectedFlag && answerFlag.subGroup) {
                <div class="table-outer-container">
                  <div class="table-container">
                    <div class="table-card">
                      <div class="table-header-title">
                        <div class="title">
                          {{ taxpayerAlias }}
                        </div>
                        <div
                          class="icon"
                          (click)="
                            answerFlag.subGroup['isCollapsed'] = !answerFlag
                              .subGroup.isCollapsed
                          "
                        >
                          <i
                            class="chevron icon"
                            [ngClass]="{
                              down: answerFlag.subGroup.isCollapsed,
                              up: !answerFlag.subGroup.isCollapsed
                            }"
                          ></i>
                        </div>
                      </div>
                      @if (!answerFlag.subGroup.isCollapsed) {
                      <div class="table-body">
                        <table
                          cellpadding="0"
                          cellspacing="0"
                          class="sticky-header"
                        >
                          <thead>
                            <tr>
                              <th class="row-num"></th>
                              @for (question of answerFlag.subGroup.questions;
                              track question) { @if (!question.hidden &&
                              !question.toggleOff) {
                              <th
                                title="{{ question?.question }}"
                                [ngClass]="{
                                  'checkbox-column': isBooleanCheckboxColumn(
                                    question
                                  )
                                }"
                              >
                                @if (question?.mandatory) {
                                <span
                                  class="column-mandatory"
                                  title="This column is mandatory"
                                  >*</span
                                >
                                }
                                <div class="text-ellipsis">
                                  {{ question?.question }}
                                </div>
                              </th>
                              } }
                            </tr>
                          </thead>
                          <tbody class="">
                            @for (rowAnswer of answerFlag.subGroup.rows; track
                            trackByRow(index, rowAnswer); let index = $index) {
                            <app-question-table-row
                              [rowAnswer]="rowAnswer"
                              [deleted]="false"
                              [subGroup]="answerFlag.subGroup"
                              [formGroup]="answerFlag.subGroup.formGroup"
                              [groupId]="answerFlag.subGroup.id"
                              [rowIndex]="index"
                              [readonly]="true"
                              [readonlyGlobal]="true"
                              [isSelected]="
                                answerFlag.subGroup.activeRow === index
                              "
                              [hideClearOverRideQuestionIcon]="true"
                            ></app-question-table-row>
                            }
                          </tbody>
                        </table>
                        @if (answerFlag && (answerFlag.totalLength &&
                        answerFlag.totalLength > answerFlag.showedUpto ) &&
                        !showInfo) {
                        <button
                          class="ui primary background button approve top-padded"
                          (click)="loadTaxpayersTableMoreData(answerFlag)"
                        >
                          {{ "taxReturns.load-more" | transloco }}
                        </button>
                        }
                      </div>
                      }
                    </div>
                  </div>
                </div>
                }
              </div>
              }
            </div>
            }
          </div>
        </div>
      </div>
      <!--    For each tax return display a table-->
      @if (question && question.taxReturns && !selectedTaxReturnFlag) {
      <div class="table-outer-container">
        @for (tr of question.taxReturns; track trackByTaxReturn(i, tr); let i =
        $index) {
        <div class="table-container">
          @if (numberOfTablesShowed >= (i+1 )) {
          <div class="table-wrapper">
            <span class="table-header-name"
              >{{ tr.atlasId }} {{ tr.firstName }} {{ tr.lastName }}
            </span>
            <div class="table-card">
              <div class="table-header-title">
                <div class="title">
                  {{ question?.parentQuestion?.question }}
                </div>
                <div class="icon" (click)="tr['isCollapsed'] = !tr.isCollapsed">
                  <i
                    class="chevron icon"
                    [ngClass]="{ down: tr.isCollapsed, up: !tr.isCollapsed }"
                  ></i>
                </div>
              </div>
              <div class="table-body">
                @if (!tr.isCollapsed) {
                <table cellpadding="0" cellspacing="0" class="sticky-header">
                  <thead>
                    <tr>
                      <th class="row-num"></th>
                      @for (question of tr.subGroup.questions; track question) {
                      @if (!question.hidden && !question.toggleOff) {
                      <th
                        title="{{ question?.question }}"
                        [ngClass]="{
                          'checkbox-column': isBooleanCheckboxColumn(question)
                        }"
                      >
                        @if (question?.mandatory) {
                        <span
                          class="column-mandatory"
                          title="This column is mandatory"
                          >*</span
                        >
                        }
                        <div class="text-ellipsis">
                          {{ question?.question }}
                        </div>
                      </th>
                      } }
                    </tr>
                  </thead>
                  <tbody class="">
                    @for (rowAnswer of tr.subGroup.rows; track trackByRow(index,
                    rowAnswer); let index = $index) {
                    <app-question-table-row
                      [rowAnswer]="rowAnswer"
                      [deleted]="false"
                      [subGroup]="tr.subGroup"
                      [formGroup]="tr.subGroup.formGroup"
                      [groupId]="tr.subGroup.id"
                      [rowIndex]="index"
                      [readonly]="true"
                      [readonlyGlobal]="true"
                      [isSelected]="tr.subGroup.activeRow === index"
                      [hideClearOverRideQuestionIcon]="true"
                    ></app-question-table-row>
                    }
                  </tbody>
                </table>
                } @if ((tr.showedUpto && tr.totalLength) && (tr.totalLength >
                tr.showedUpto) && !showInfo) {
                <button
                  class="ui primary background button approve top-padded"
                  (click)="loadTaxpayersTableFromTaxReturnMoreData(tr)"
                >
                  {{ "taxReturns.load-more" | transloco }}
                </button>
                }
              </div>
            </div>
          </div>
          } @if (i === numberOfTablesShowed) {
          <div>
            @if (!showInfo) {
            <button
              class="ui primary background button approve top-padded"
              (click)="loadMoreTables()"
            >
              {{ "taxReturns.load-more" | transloco }}
            </button>
            }
          </div>
          }
        </div>
        }
      </div>
      }
      <!--    On warning selection -->
      @if (question && selectedFlag && selectedFlag.subGroup) {
      <div class="table-outer-container">
        <div class="table-container">
          <div class="table-card">
            <div class="table-header-title">
              <div class="title">
                {{ taxpayerAlias }}
              </div>
              <div
                class="icon"
                (click)="
                  selectedFlag.subGroup['isCollapsed'] = !selectedFlag.subGroup
                    .isCollapsed
                "
              >
                <i
                  class="chevron icon"
                  [ngClass]="{
                    down: selectedFlag.subGroup.isCollapsed,
                    up: !selectedFlag.subGroup.isCollapsed
                  }"
                ></i>
              </div>
            </div>
            @if (!selectedFlag.subGroup.isCollapsed) {
            <div class="table-body">
              <table cellpadding="0" cellspacing="0" class="sticky-header">
                <thead>
                  <tr>
                    <th class="row-num"></th>
                    @for (question of selectedFlag.subGroup.questions; track
                    question) { @if (!question.hidden && !question.toggleOff) {
                    <th
                      title="{{ question?.question }}"
                      [ngClass]="{
                        'checkbox-column': isBooleanCheckboxColumn(question)
                      }"
                    >
                      @if (question?.mandatory) {
                      <span
                        class="column-mandatory"
                        title="This column is mandatory"
                        >*</span
                      >
                      }
                      <div class="text-ellipsis">{{ question?.question }}</div>
                    </th>
                    } }
                  </tr>
                </thead>
                <tbody class="">
                  @for (rowAnswer of selectedFlag.subGroup.rows; track
                  trackByRow(index, rowAnswer); let index = $index) {
                  <app-question-table-row
                    [rowAnswer]="rowAnswer"
                    [deleted]="false"
                    [subGroup]="selectedFlag.subGroup"
                    [formGroup]="selectedFlag.subGroup.formGroup"
                    [groupId]="selectedFlag.subGroup.id"
                    [rowIndex]="index"
                    [readonly]="true"
                    [readonlyGlobal]="true"
                    [isSelected]="selectedFlag.subGroup.activeRow === index"
                    [hideClearOverRideQuestionIcon]="true"
                  >
                  </app-question-table-row>
                  }
                </tbody>
              </table>
              @if (selectedFlag && selectedFlag.showedUpto && (
              selectedFlag.totalLength > selectedFlag.showedUpto ) && !showInfo)
              {
              <button
                class="ui primary background button approve top-padded"
                (click)="loadTaxpayersTableMoreData(selectedFlag)"
              >
                {{ "taxReturns.load-more" | transloco }}
              </button>
              }
            </div>
            }
          </div>
        </div>
      </div>
      }
    </div>
    }
  </div>
  } @if ( tab === 3 && taxReturnStructure && taxReturnStructure.length &&
  !loadingWarning ) {
  <div class="batch-warnings__body">
    <div class="no-warnings-info">
      @if (( showActiveAnswerWarnings && !batchHasComments )) {
      <div>{{ "taxReturns.no-active-warnings" | transloco }}</div>
      }
    </div>
    <div class="left-bar hidden-scrollbar">
      @for (category of taxReturnStructure; track category) {
      <div class="category">
        @if (isItHasWarnings(category, tab)) {
        <div class="count">
          <div
            class="title"
            (click)="category['isCollapsed'] = !category.isCollapsed"
          >
            <i
              class="chevron icon"
              [ngClass]="{
                down: category.isCollapsed,
                up: !category.isCollapsed
              }"
            ></i>
            {{ category.name }}
          </div>
          @for (subCategory of category.subcategories; track subCategory) {
          <div [hidden]="category.isCollapsed" class="subcategory">
            @if (isItHasWarnings(subCategory, tab)) {
            <div>
              <div
                class="title"
                (click)="subCategory['isCollapsed'] = !subCategory.isCollapsed"
              >
                <i
                  class="chevron icon"
                  [ngClass]="{
                    down: subCategory.isCollapsed,
                    up: !subCategory.isCollapsed
                  }"
                ></i>
                {{ subCategory.name }}
              </div>
              @for (_question of subCategory['questions']; track _question) {
              <div class="question-group" [hidden]="subCategory.isCollapsed">
                @if (isItHasWarnings(_question, tab)) {
                <div>
                  <div
                    class="question"
                    (click)="selectQuestionComment(_question)"
                    [ngClass]="{
                      active: question?.id === _question.id,
                      not_selected: question?.id !== _question.id
                    }"
                  >
                    {{ _question?.id }}.{{ _question.question }}
                  </div>
                  <div class="question-warnings">
                    <!--  answerFlags  -->
                    @if (commentsByQuestionId[_question?.id]) {
                    <div class="d-flex question-group-answer-warnings">
                      <div class="d-flex">
                        <div class="warning-container">
                          @for (sortedComment of
                          commentsByQuestionId[_question?.id]['sortedComments'];
                          track sortedComment) {
                          <div>
                            <div class="warning-taxReturn">
                              <span
                                (click)="
                                  selectQuestionComment(
                                    _question,
                                    sortedComment[0].taxReturnId
                                  )
                                "
                              >
                                {{ sortedComment[0].atlasId }}.
                                {{ sortedComment[0].firstName }}
                                {{ sortedComment[0].lastName }}
                              </span>
                              &#8618;
                              <span
                                class="link"
                                (click)="
                                  goToWarning(
                                    sortedComment[0].taxReturnId,
                                    subCategory.id,
                                    _question?.id
                                  )
                                "
                                >{{
                                  "taxReturns.go-to-section" | transloco
                                }}</span
                              >
                            </div>
                          </div>
                          }
                        </div>
                      </div>
                    </div>
                    }
                  </div>
                </div>
                }
              </div>
              }
            </div>
            }
          </div>
          }
        </div>
        }
      </div>
      }
    </div>
    @if (question) {
    <div class="table-group right-bar">
      <header class="question-warnings-header">
        <h3>{{ question.question }}</h3>
        @if (selectedFlag) {
        <div class="header-action-area">
          <small>
            {{ 'taxReturns.visit-the-tax-return-alias-section-from-the-left-menu' | transloco: {taxReturnAlias}
            }}<br />
            {{ "taxReturns.to-clear-this-warning" | transloco }}
          </small>
        </div>
        }
      </header>
      <div class="list-container">
        <div class="list-inner-cont">
          <div class="question-warnings">
            <!--  answerComments  -->
            @if (commentsByQuestionId[question?.id]) {
            <div class="d-flex question-group-answer-warnings-table">
              <div class="d-flex sorted-warning-item">
                @if (question && commentsByQuestionId[question?.id].subGroup) {
                <div class="table-outer-container">
                  <div class="table-container">
                    <div class="table-card">
                      <div class="table-header-title">
                        <div class="title">
                          {{ taxpayerAlias }}
                        </div>
                        <div
                          class="icon"
                          (click)="
                            commentsByQuestionId[question?.id].subGroup[
                              'isCollapsed'
                            ] = !commentsByQuestionId[question?.id].subGroup
                              .isCollapsed
                          "
                        >
                          <i
                            class="chevron icon"
                            [ngClass]="{
                              down:
                                commentsByQuestionId[question?.id].subGroup
                                  .isCollapsed,
                              up: !commentsByQuestionId[question?.id].subGroup
                                .isCollapsed
                            }"
                          ></i>
                        </div>
                      </div>
                      @if
                      (!commentsByQuestionId[question?.id].subGroup.isCollapsed)
                      {
                      <div class="table-body">
                        <table
                          cellpadding="0"
                          cellspacing="0"
                          class="sticky-header"
                        >
                          <thead>
                            <tr>
                              <th class="row-num"></th>
                              @for (question of
                              commentsByQuestionId[question?.id].subGroup.questions;
                              track question) { @if (!question.hidden &&
                              !question.toggleOff) {
                              <th
                                title="{{ question?.question }}"
                                [ngClass]="{
                                  'checkbox-column': isBooleanCheckboxColumn(
                                    question
                                  )
                                }"
                              >
                                @if (question?.mandatory) {
                                <span
                                  class="column-mandatory"
                                  title="This column is mandatory"
                                  >*</span
                                >
                                }
                                <div class="text-ellipsis">
                                  {{ question?.question }}
                                </div>
                              </th>
                              } }
                            </tr>
                          </thead>
                          <tbody class="">
                            @for (rowAnswer of
                            commentsByQuestionId[question?.id].subGroup.rows;
                            track trackByRow(index, rowAnswer); let index =
                            $index) {
                            <app-question-table-row
                              [rowAnswer]="rowAnswer"
                              [deleted]="false"
                              [subGroup]="
                                commentsByQuestionId[question?.id].subGroup
                              "
                              [formGroup]="
                                commentsByQuestionId[question?.id].subGroup
                                  .formGroup
                              "
                              [groupId]="
                                commentsByQuestionId[question?.id].subGroup.id
                              "
                              [rowIndex]="index"
                              [readonly]="true"
                              [readonlyGlobal]="true"
                              [isSelected]="
                                commentsByQuestionId[question?.id].subGroup
                                  .activeRow === index
                              "
                              [hideClearOverRideQuestionIcon]="true"
                            ></app-question-table-row>
                            }
                          </tbody>
                        </table>
                        @if (commentsByQuestionId[question?.id] &&
                        (commentsByQuestionId[question?.id].totalLength &&
                        commentsByQuestionId[question?.id].totalLength >
                        commentsByQuestionId[question?.id].showedUpto ) &&
                        !showInfo) {
                        <button
                          class="ui primary background button approve top-padded"
                          (click)="
                            loadTaxpayersTableMoreData(
                              commentsByQuestionId[question?.id]
                            )
                          "
                        >
                          {{ "taxReturns.load-more" | transloco }}
                        </button>
                        }
                      </div>
                      }
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>
            }
          </div>
        </div>
      </div>
      <!--    For each tax return display a table-->
      @if (question && question.taxReturns && !selectedTaxReturnFlag) {
      <div class="table-outer-container">
        @for (tr of question.taxReturns; track trackByTaxReturn(i, tr); let i =
        $index) {
        <div class="table-container">
          @if (numberOfTablesShowed >= (i+1 )) {
          <div class="table-wrapper">
            <span class="table-header-name"
              >{{ tr.atlasId }} {{ tr.firstName }} {{ tr.lastName }}
            </span>
            <div class="table-card">
              <div class="table-header-title">
                <div class="title">
                  {{ question?.parentQuestion?.question }}
                </div>
                <div class="icon" (click)="tr['isCollapsed'] = !tr.isCollapsed">
                  <i
                    class="chevron icon"
                    [ngClass]="{ down: tr.isCollapsed, up: !tr.isCollapsed }"
                  ></i>
                </div>
              </div>
              <div class="table-body">
                @if (!tr.isCollapsed) {
                <table cellpadding="0" cellspacing="0" class="sticky-header">
                  <thead>
                    <tr>
                      <th class="row-num"></th>
                      @for (question of tr.subGroup.questions; track question) {
                      @if (!question.hidden && !question.toggleOff) {
                      <th
                        title="{{ question?.question }}"
                        [ngClass]="{
                          'checkbox-column': isBooleanCheckboxColumn(question)
                        }"
                      >
                        @if (question?.mandatory) {
                        <span
                          class="column-mandatory"
                          title="This column is mandatory"
                          >*</span
                        >
                        }
                        <div class="text-ellipsis">
                          {{ question?.question }}
                        </div>
                      </th>
                      } }
                    </tr>
                  </thead>
                  <tbody class="">
                    @for (rowAnswer of tr.subGroup.rows; track trackByRow(index,
                    rowAnswer); let index = $index) {
                    <app-question-table-row
                      [rowAnswer]="rowAnswer"
                      [deleted]="false"
                      [subGroup]="tr.subGroup"
                      [formGroup]="tr.subGroup.formGroup"
                      [groupId]="tr.subGroup.id"
                      [rowIndex]="index"
                      [readonly]="true"
                      [readonlyGlobal]="true"
                      [isSelected]="tr.subGroup.activeRow === index"
                      [hideClearOverRideQuestionIcon]="true"
                    ></app-question-table-row>
                    }
                  </tbody>
                </table>
                } @if ((tr.showedUpto && tr.totalLength) && (tr.totalLength >
                tr.showedUpto) && !showInfo) {
                <button
                  class="ui primary background button approve top-padded"
                  (click)="loadTaxpayersTableFromTaxReturnMoreData(tr)"
                >
                  {{ "taxReturns.load-more" | transloco }}
                </button>
                }
              </div>
            </div>
          </div>
          } @if (i === numberOfTablesShowed) {
          <div>
            @if (!showInfo) {
            <button
              class="ui primary background button approve top-padded"
              (click)="loadMoreTables()"
            >
              {{ "taxReturns.load-more" | transloco }}
            </button>
            }
          </div>
          }
        </div>
        }
      </div>
      } @if (comments) {
      <div id="comments-list-container">
        <div id="comments">
          <div class="flex-aligner"></div>
          <ng-template
            #commentTemplate
            let-comment="comment"
            let-isParent="isParent"
            let-index="index"
          >
            <div class="comment" [ngClass]="{ reply: !isParent }">
              <div class="commenter-name">
                {{ comment?.author }}
                <div class="comment-date">{{ comment?.date }}</div>
              </div>
              <div class="comment-labels">
                @if (isParent) { @for (field of comment.commentFields; track
                field) {
                <div>
                  <span class="comment-tax-return-name">
                    <span class="field-label ui label"
                      >{{ field?.atlasId }}.{{ field?.firstName }}
                      {{ field?.lastName }}
                    </span>
                  </span>
                  @if (showQuestionId) {
                  <span>{{ field?.id }}.</span>
                  }
                  <span class="field-label ui label">{{
                    field?.question
                  }}</span>
                </div>
                } }
              </div>
              <div class="comment-text">
                <app-comment
                  [comment]="comment"
                  [documents]="documents"
                ></app-comment>
              </div>
              @if (isParent) { @for (reply of comment.comments; track reply) {
              <div>
                <ng-container
                  *ngTemplateOutlet="
                    commentTemplate;
                    context: { comment: reply, isParent: false }
                  "
                >
                </ng-container>
              </div>
              } }
            </div>
          </ng-template>
          @for (commentItem of comments|orderBy:['dateMoment']:['asc']; track
          commentItem; let index = $index) {
          <ng-container
            *ngTemplateOutlet="
              commentTemplate;
              context: { comment: commentItem, isParent: true, index: index }
            "
          >
          </ng-container>
          }
        </div>
      </div>
      }
    </div>
    }
  </div>
  }

  <div #saveModal id="save-all-modal" class="ui tiny modal">
    <div class="modal-close close icon"></div>

    <h1>{{ "taxReturns.respond-and-close-all" | transloco }}</h1>

    <div class="content">
      <p>
        {{ 'taxReturns.respond-and-close-number-of-answer-warnings' | transloco: {numberOfAnswerWarningsToRespondTo} }}
        <br />
        {{ "taxReturns.question-colon" | transloco }} {{ question?.question }}
        <br />
        {{ "taxReturns.warning-colon" | transloco }} {{ selectedWarning?.name }}
        <br />
        {{
          "taxReturns.please-make-sure-your-comment-is-finished-before-you-save"
            | transloco
        }}
        Please make sure your comment is finished before you save.
      </p>

      @for (field of commentFields; track field) {
      <div class="ui label">
        {{ field?.question }} ({{ field?.groupName }} @if (field?.groupName &&
        field?.subGroupName) {
        <span>-</span>
        }
        {{ field?.subGroupName }}@if (field?.rowIndex != null) {
        <span> - row {{ field?.rowIndex + 1 }}</span>
        })
      </div>
      }

      <textarea
        [formControl]="comment"
        id="comment-textbox"
        placeholder="Type your comment here..."
      ></textarea>
    </div>

    <div class="actions">
      <span class="go-back deny">{{
        "taxReturns.no-go-back" | transloco
      }}</span>

      <div
        class="ui primary background button"
        (click)="respondAndCloseAll()"
        [ngClass]="{ disabled: !comment.value || isSaving }"
      >
        @if (!isSaving) {
        <span>{{ "taxReturns.respond-and-close" | transloco }}</span>
        } @if (isSaving) {
        <span class="ui active inline loader"></span>
        }
      </div>
    </div>
  </div>
</div>
@if (loadingWarning) {
<div class="ui active inverted dimmer" [ngClass]="{ dimmed: loadingWarning }">
  <div class="ui large text loader">{{ "taxReturns.loading" | transloco }}</div>
</div>
}
